import { useState } from 'react';
import {
  Button,
  Col,
  Form,
  Offcanvas,
  Row
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { Formik } from 'formik';
import _ from 'lodash';
import {
  useCreateCompetitorMutation,
  useDeleteCompetitorMutation,
  useGetCompetitorsForSelectQuery,
  useGetTariffInfoQuery,
} from '@/app/KeywordTracker/api/keywordsApi';

import { errorMessage, successMessage } from '@/utils/toast';
import CancelModal from '@/app/common/components/CancelModal';
import Flex from '@/components/common/Flex';
import { object, string } from 'yup';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';



const ManageCompetitorDrawer = ({ show, setShow, domain, domain_slug }) => {
  const { data: userInfo } = useGetUserInfoQuery();
  const [createCompetitor] = useCreateCompetitorMutation();
  const { data: trackerInfo, isFetching: isFetchingTrackerInfo } =
    useGetTariffInfoQuery(domain_slug);
  const { data: competitors, isLoading } =
    useGetCompetitorsForSelectQuery(domain_slug);
  const isAccessAllowed = () =>
    trackerInfo?.data?.access_level !== 3 && !isFetchingTrackerInfo;
  const [deleteCompetitor] = useDeleteCompetitorMutation();
  const [triggeredRem, setTriggeredRem] = useState(false);
  return (
    <Offcanvas
      onShow={() => {
        const offcanvasElement = document.querySelector('.offcanvas');
        if (offcanvasElement) {
          offcanvasElement.removeAttribute('tabindex');
        }
      }}
      show={show}
      onHide={() => {
        setShow(false);
      }}
      style={{ backgroundColor: 'var(--falcon-body-bg)' }}
    >
      <CancelModal
        submitTitle="آره، حذف بشه"
        desc={
          <>
            آیا از حذف رقیب <strong>{triggeredRem.url}</strong> مطمئن هستی؟
          </>
        }
        show={triggeredRem}
        title="حذف رقیب"
        setShow={setTriggeredRem}
        submitFunc={() => {
          deleteCompetitor({
            domain_slug,
            competitor_ids: [triggeredRem.id]
          })
            .unwrap()
            .then(() => {
              successMessage('رقیب با موفقیت حذف شد');
            })
            .catch(err => {
              errorMessage('خطایی در حذف رقیب وجود داره');
              console.error(err);
            });
        }}
      />
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="m-0">
              مدیریت رقیب
              {/* <HelpTooltip html={'23'} /> */}
            </div>
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="my-0" />
      <Offcanvas.Body className="pb-5 pt-0">
        {/* {competitors?.data?.length > 0 && (
          <div className="mt-4">
            فهرست رقیب 
            <hr />
          </div>
        )} */}
        <div
          className="border rounded-3 p-3 my-3"
          style={{
            overflowY: 'scroll',
            display: competitors?.data?.length > 0 ? 'block' : 'none',
            maxHeight: 300
          }}
        >
          {!isLoading &&
            competitors?.data?.map(competitor => (
              <div key={competitor?.id}>
                <Form.Group>
                  <Form.Label className="d-flex fs-0 my-3 gap-3 justify-content-start align-items-center">
                    <Button
                      onClick={() => setTriggeredRem(competitor)}
                      variant="danger"
                      className="d-flex gap-2 align-items-center"
                      style={{ padding: '0.3em' }}
                    >
                      <FontAwesomeIcon icon="trash-alt" className="fs-0" />{' '}
                    </Button>
                    {competitor?.url}{' '}
                  </Form.Label>
                </Form.Group>
              </div>
            ))}
        </div>

        <Formik
          validationSchema={object().shape({
            url: string()
              .trim()
              .required('وارد کردن دامنه الزامی می‌باشد')
              .test(
                'is-not-http-or-www',
                'دامنه نباید با http، https یا www شروع شود',
                value => {
                  if (!value || value.length < 3) return true; // اگر تعداد کاراکتر کمتر از ۳ است بررسی نکن
                  return /^(?!https?:\/\/|www\.)[^\s/$.?#].[^\s]*$/.test(value); // رجکس را چک کن
                }
              )
              .test(
                'contains-dot',
                'دامنه نامعتبر است. لطفا یک دامنه معتبر وارد کنید.',
                value => (value ? value.includes('.') : true) // بررسی وجود نقطه
              )
              .test(
                'no-slash',
                'لطفا "/" و هرآنچه بعد از آن را پاک کنید. ',
                value => !value.includes('/') // بررسی عدم وجود "/"
              )
              .max(50, 'دامنه رقیب نباید بیش از ۵۰ کاراکتر باشد.'),
            show_name: string().max(20, 'عنوان نباید بیش از ۲۰ کاراکتر باشد')
          })}
          onSubmit={async ({ url, show_name }, action) => {
            createCompetitor({
              domain_slug,
              url: url.trim(),
              show_name: show_name.trim()
            })
              .unwrap()
              .then(res => {
                if (res?.success) successMessage('رقیب با موفقیت اضافه شد');
                else if (res?.resultCode === 50004)
                  errorMessage('رقیب با این دامنه وجود داره');
                setShow(false);
              })
              .catch(err => {
                errorMessage('خطایی در ایجاد رقیب وجود داره');
                console.error(err);
              });
          }}
          initialValues={{ url: '', show_name: '' }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue
          }) => (
            <Form
              onSubmit={e => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <Row className="g-3 mt-4">
                <Col md={7}>
                  <div className=" mb-2">دامنه رقیب</div>
                  <div className="d-flex fs--1 flex-column">
                    <Form.Group>
                      <Form.Control
                        onBlur={handleBlur}
                        onChange={handleChange}
                        style={{ direction: 'ltr' }}
                        id="url"
                        name="url"
                        value={values.url}
                        isInvalid={touched.url && errors.url}
                        isValid={touched.url && !errors.url}
                        placeholder={`mizfa.com`}
                      />
                      <Form.Control.Feedback
                        type={errors.url ? 'invalid' : 'valid'}
                        className="fs--1 ms-2 mt-2 d-block"
                      >
                        {errors.url && touched.url && errors.url}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </Col>
                <Col>
                  <div className=" mb-2">نام نمایشی</div>
                  <div className="d-flex fs--1 flex-column">
                    <Form.Control
                      onBlur={handleBlur}
                      onChange={handleChange}
                      id="show_name"
                      name="show_name"
                      value={values.show_name}
                      placeholder={`میزفاتولز`}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className="fs--1 ms-2 mt-2 d-block"
                    >
                      {errors.show_name &&
                        touched.show_name &&
                        errors.show_name}
                    </Form.Control.Feedback>
                  </div>
                </Col>
              </Row>
              <div className="fs--1 mt-2 text-secondary">
                لطفا دامنه رو با "www"، "http" و "https" وارد نکنید، مانند:{' '}
                <strong>mizfa.com</strong>
              </div>

              <Flex
                className="mt-3"
                justifyContent="between"
                alignItems="center"
              >
                <div>
                  <span className="mx-1 text-success">
                    {trackerInfo?.data?.used?.num_of_competitors}
                  </span>
                  رقیب از
                  <span className="mx-1 text-info">
                    {trackerInfo?.data?.tariff?.num_of_competitors}
                  </span>
                  رقیب اضافه شده.
                </div>
              </Flex>

              <div className="position-sm-absolute bottom-0 d-flex gap-2 end-0 justify-content-end p-sm-4 pb-7 pt-2">
                <Button
                  className="d-flex gap-2 align-items-center"
                  variant="outline-secondary"
                  onClick={() => setShow(false)}
                >
                  <FontAwesomeIcon size="lg" icon="times" />
                  لغو
                </Button>
                <ChildrensTooltip
                  placement="top"
                  html={
                    trackerInfo?.data?.tariff?.num_of_competitors -
                      trackerInfo?.data?.used?.num_of_competitors <=
                    0
                      ? 'تعداد رقیب ها با طرح خریداری شده مطابقت ندارد.'
                      : !isAccessAllowed()
                        ? 'شما دسترسی لازم را ندارید.'
                        : ''
                  }
                >
                  <Button
                    disabled={
                      // values.url.length === 0 ||
                      trackerInfo?.data?.tariff?.num_of_competitors -
                        trackerInfo?.data?.used?.num_of_competitors <=
                      0
                    }
                    className="d-flex gap-2 align-items-center border-0"
                    // onClick={() => handleSubmit()}
                    type="submit"
                    variant="falcon-primary"
                  >
                    <FontAwesomeIcon size="lg" icon="plus" />
                    اعمال کن
                  </Button>
                </ChildrensTooltip>
              </div>
            </Form>
          )}
        </Formik>
      </Offcanvas.Body>

      <style>
        {/* استایل کلی دراور */}
        {`
 .offcanvas{
     width:500px !important;
      max-width:100% !important;
    }
  .offcanvas img {
    margin: 0 auto;
    max-width: 100%;
    height: auto;
    display: flex;
    }
 `}
        *
      </style>
    </Offcanvas>
  );
};

export default ManageCompetitorDrawer;
